/**
 * Responsive CSS for Menu prebuilt blocks.
 * Keeps nav items as inline chips that wrap (matches builder flex-wrap).
 */
export const MENU_RESPONSIVE_CSS = `
  .menu-block-wrap {
    box-sizing: border-box;
  }
  .menu-block-table {
    width: 100%;
  }
  .menu-links-cell {
    vertical-align: middle !important;
    line-height: 1.25;
  }
  .menu-item-link {
    display: inline-block !important;
    vertical-align: middle !important;
    line-height: 1.25 !important;
  }

  @media only screen and (max-width: 768px) {
    .menu-block-wrap {
      padding: 14px 16px !important;
    }
    .menu-links-cell {
      text-align: center !important;
    }
    .menu-item-link {
      font-size: 12px !important;
      padding: 7px 10px !important;
      white-space: nowrap !important;
      margin: 4px !important;
    }
  }
`;
